module.exports = __webpack_public_path__ + "static/media/PaidIcon.af25493e.svg";